export default "__VITE_ASSET__DcP0tOZ3__"